module.exports = __webpack_public_path__ + "static/img/screen_bg2.4c526f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bigScreen/screen_bg2.png
// module id = koPt
// module chunks = 1